
// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.variantgroups', {
        url: '/variantgroups',
        views: {'productList@product': {
            templateUrl: 'main/product/variantgroups/variantgroups.tpl.html',
            controller: 'VariantGroupsController as vm'
        }},
        resolve: {
            variantGroups: variantGroupsResolver
        }
    });
}

// @ngInject
function variantGroupsResolver(VariantGroupsApiService) {
    return VariantGroupsApiService.getVariantGroupBriefs(1, '', 20);
}

// @ngInject
function VariantGroupsController($rootScope, $state, $scope, variantGroups, VariantGroupsApiService, loadSpinnerService) {
    var vm = this;

    //Properties
    vm.currentUser = $rootScope.currentUser;
    vm.variantGroups = variantGroups.data;
    vm.totalItems = variantGroups.totalItems;
    vm.selectedVariantGroupId = 0;
    vm.searchTerm = '';
    vm.currentPage = 1;
    vm.itemsPerPage = 20;

    //Methods
    vm.searchTermChange = searchTermChange;
    vm.loadVariantGroups = loadVariantGroups;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.variantGroupId; }, function(newValue, oldValue) {
            vm.selectedVariantGroupId = parseInt($state.params.variantGroupId, 10);
        });
    }

    function loadVariantGroups() {
        loadSpinnerService.start('mainSpinner');
        VariantGroupsApiService.getVariantGroupBriefs(vm.currentPage,vm.searchTerm,vm.itemsPerPage).then(function(response) {
            vm.variantGroups = response.data;
            vm.totalItems = response.totalItems;
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadVariantGroups();
    }
    $rootScope.$on('VariantGroup.Inserted', function(event, response) {
    });
    $rootScope.$on('VariantGroup.Updated', function(event, response) {
    });
    $rootScope.$on('VariantGroup.Deleted', function(event, response) {
    });
    $rootScope.$on('VariantGroup.Changed', function(event, response) {
        loadVariantGroups();
    });

}

angular
    .module('product.variantgroups', ['product.variantgroups.variantgroup'])
    .config(stateConfig)
    .controller('VariantGroupsController', VariantGroupsController);
